export default __webpack_public_path__ + "static/media/bindingsoftheskylord.1c7df1eb.png";